require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _Icon = _interopRequireDefault(require("../Icon"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/List/ListIcon.tsx";

var ListIcon = function (_React$Component) {
  (0, _inherits2["default"])(ListIcon, _React$Component);

  function ListIcon() {
    (0, _classCallCheck2["default"])(this, ListIcon);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ListIcon).apply(this, arguments));
  }

  (0, _createClass2["default"])(ListIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          iconColor = _this$props.color,
          style = _this$props.style;
      return React.createElement(_reactNative.View, {
        style: [styles.item, style],
        pointerEvents: "box-none",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        }
      }, React.createElement(_Icon["default"], {
        source: icon,
        size: 24,
        color: iconColor,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 40
        }
      }));
    }
  }]);
  return ListIcon;
}(React.Component);

exports["default"] = ListIcon;
(0, _defineProperty2["default"])(ListIcon, "displayName", 'List.Icon');

var styles = _reactNative.StyleSheet.create({
  item: {
    margin: 8,
    height: 40,
    width: 40,
    alignItems: 'center',
    justifyContent: 'center'
  }
});